import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import CookieBanner from "@/components/CookieBanner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Myths from "@/pages/Myths";
import Nutrition from "@/pages/Nutrition";
import { Blog, Article } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import { Login, Register } from "@/pages/Auth";
import Paywall from "@/pages/Paywall";
import { Dashboard, Recipe } from "@/pages/Plan";
import Admin from "@/pages/Admin";
import { Impressum, AGB, Datenschutz } from "@/pages/Legal";
import Wissenschaft from "@/pages/Wissenschaft";
import FAQ from "@/pages/FAQ";
import WarumLacLive from "@/pages/WarumLacLive";
import AuthCallback from "@/pages/AuthCallback";

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function AppRouter() {
  // Synchronously detect OAuth callback fragment before normal routing runs
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/ueber-lactoseintoleranz" element={<About />} />
        <Route path="/mythen-und-fakten" element={<Myths />} />
        <Route path="/ernaehrung" element={<Nutrition />} />
        <Route path="/artikel" element={<Blog />} />
        <Route path="/artikel/:slug" element={<Article />} />
        <Route path="/wissenschaft" element={<Wissenschaft />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/warum-laclive" element={<WarumLacLive />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/paywall" element={<Paywall />} />
        <Route path="/plan" element={<ProtectedRoute requiresAccess={true}><Dashboard /></ProtectedRoute>} />
        <Route path="/plan/rezept/:slug" element={<ProtectedRoute requiresAccess={true}><Recipe /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/agb" element={<AGB />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
